import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Clients need deadlines too",
  "description": "",
  "published": "2010-11-10T00:00:00.000Z",
  "redirect_from": ["/blog/?p=1489"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Perhaps everyone knows about this problem already and I've just been very fortunate, or maybe it's one of those things that happens so rarely nobody really feels the need to talk about it. Or any other number of reasons why I have yet to notice a blog about why clients should have clearly defined deadlines too.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      